var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, customElement } from "lit-element";
import { FetchElement } from "../fetch-element";
import '../status-element';
let StatusFetchElement = class StatusFetchElement extends FetchElement {
    renderOnFetchSuccessful() {
        return html `
      <status-element .status=${this._fetchData.json} fetchUrl=${this.fetchUrl} updateIntervalSeconds=${this.updateIntervalSeconds}></status-element>
    `;
    }
};
StatusFetchElement = __decorate([
    customElement('status-fetch-element')
], StatusFetchElement);
export { StatusFetchElement };
